import { FC, useMemo } from "react";
import { Center, Stack, Text } from "@chakra-ui/react";

interface Props {
  isScheduleError: boolean;
  isDebtError: boolean;
}

export const MainPagePaymentScheduleError: FC<Props> = ({ isScheduleError, isDebtError }) => {
  const message = useMemo(() => {
    let result = "";

    if (isScheduleError) {
      result = "график платежей";
    }

    if (isDebtError) {
      result = "информацию о задолженности";
    }

    return result;
  }, [isScheduleError, isDebtError]);

  return (
    <Stack bg="white" borderRadius="16px" px="20px" py="16px" w="100%" h="215px">
      <Center flex="1" flexDirection="column">
        <Text variant="brand" textAlign="center">Не удалось загрузить</Text>
        <Text variant="brand" textAlign="center">{message}</Text>
      </Center>
    </Stack>
  );
};
